/**
 * 客服联系信息服务
 */

import { uuid } from "@/utils";

interface ServiceInfo {
    name: string;
    url: string;
    icon: string;
}

const fromId = uuid();

export const wangwangService: ServiceInfo = {
    name: "",
    url: `https://amos.alicdn.com/getcid.aw?v=3&uid=l95566505&site=cntaobao&groupid=160079865&s=1&charset=utf-8&fromid=${fromId}`,
    icon: "https://img.alicdn.com/tps/i4/T1uUG.XjtkXXcb2gzo-77-19.gif",
};

let qqService: ServiceInfo | undefined = {
    name: "800183878",
    url: " http://q.url.cn/ab3QoS?_type=wpa&qidian=true",
    icon: "https://pub.idqqimg.com/qconn/wpa/button/button_111.gif",
};

let weChatService: ServiceInfo | undefined = {
    name: "二维码",
    url: "https://cdn.fahuoyi.com/www/images/common/wechat-qrcode.jpg",
    icon: "https://img.alicdn.com/imgextra/i3/54458674/O1CN01jSsfFG2DwkBD9S6SG_!!54458674.png",
};

if (import.meta.env.VITE_IS_QN) {
    qqService = undefined;
    weChatService = undefined;
}

export { qqService, weChatService };
